import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';
import { findRecord } from '@warp-drive/utilities/json-api';
import { getItemStats, getMentionsForItem } from '../../builders/items.ts';
import type { Item } from '../../schemas/item.ts';
import type { ItemStats } from '../../schemas/item-stats.ts';
import type { Mention } from '../../schemas/mention.ts';
import type { UserSource } from '../../schemas/user-source.ts';
import type { ItemsResultsParams } from './index/results.ts';
import { getUserSources } from '../../builders/profile.ts';

interface ItemParams {
  item_id: string;
}

export default class ItemsShowRoute extends Route {
  @service declare store: Store;

  queryParams = {
    myMentions: { refreshModel: true },
  };

  async model(params: Record<string, unknown>) {
    const { item_id } = params as unknown as ItemParams;
    const myMentions = params['myMentions'] === 'true';

    const [itemResult, statsResult, mentionsResult] = await Promise.all([
      this.store.request<{ data: Item }>(findRecord('item', item_id)),
      this.store.request<{ data: ItemStats }>(getItemStats(item_id)),
      this.store.request<{ data: Mention[] }>(getMentionsForItem(item_id)),
    ]);

    const item = itemResult.content.data;
    const stats = statsResult.content.data;
    let mentions = mentionsResult.content.data;

    if (myMentions) {
      const sourcesResult = await this.store.request<{
        data: UserSource[];
      }>(getUserSources({ page: '1' }));
      const mySourceIds = new Set(sourcesResult.content.data.map((s) => s.id));
      mentions = mentions.filter(
        (m) => m.contentSource && mySourceIds.has(m.contentSource.id)
      );
    }

    const itemsParams = this.paramsFor(
      'explore.index.results'
    ) as ItemsResultsParams;

    return {
      item,
      stats,
      mentions,
      myMentions,
      backQuery: {
        type: itemsParams.type ?? '',
        sort: itemsParams.sort ?? '-createdAt',
        q: itemsParams.q ?? '',
      },
    };
  }
}
